window.maximumOrderQuantity = window.maximumOrderQuantity || {
  async getCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Unable to check the cart quantity.');
    return response.json();
  },

  getVariantQuantity(cart, variantId) {
    const requestedVariantId = String(variantId);
    return cart.items.reduce((total, item) => {
      let quantity =
        String(item.variant_id) === requestedVariantId ? item.quantity : 0;
      const details = item.properties?._Details;
      if (typeof details === 'string') {
        const pattern = /(\d+)\s*:\s*(\d+)/g;
        let match;
        while ((match = pattern.exec(details)) !== null) {
          if (match[1] === requestedVariantId) {
            quantity += parseInt(match[2], 10) || 0;
          }
        }
      }
      return total + quantity;
    }, 0);
  },

  async canAdd(variantId, quantity, maximum) {
    if (!maximum || maximum < 1) return true;
    const cart = await this.getCart();
    return this.getVariantQuantity(cart, variantId) + quantity <= maximum;
  },

  setProductFormState(productForm, reached) {
    const button = productForm.querySelector('[type="submit"][name="add"]');
    const message = productForm.querySelector('.product-form__maximum-order-message');
    if (!button) return;

    if (reached) {
      if (button.dataset.baseDisabled === 'true') {
        if (message) message.hidden = true;
        return;
      }
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.dataset.maximumQuantityDisabled = 'true';
      if (message) message.hidden = false;
    } else if (button.dataset.maximumQuantityDisabled === 'true') {
      delete button.dataset.maximumQuantityDisabled;
      if (
        button.dataset.baseDisabled !== 'true' &&
        button.dataset.bundleComponentMaximumDisabled !== 'true'
      ) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      }
      if (message) message.hidden = true;
    }
  },

  syncProductForms(cart) {
    document.querySelectorAll('product-form[data-maximum-order-quantity]').forEach((productForm) => {
      const maximum = parseInt(productForm.dataset.maximumOrderQuantity, 10);
      const quantity = this.getVariantQuantity(cart, productForm.dataset.variantId);
      this.setProductFormState(productForm, maximum > 0 && quantity >= maximum);
    });
  },

  async refresh() {
    const cart = await this.getCart();
    this.syncProductForms(cart);
    return cart;
  },
};

document.addEventListener('cart:updated', () => {
  window.maximumOrderQuantity.refresh().catch((error) => console.error(error));
});
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('product-form[data-maximum-order-quantity]')) {
    window.maximumOrderQuantity.refresh().catch((error) => console.error(error));
  }
});

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-items');
      this.cartDrawer = document.getElementById("mini-cart");
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-items')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const variantId = this.form.querySelector('[name="id"]').value;
      const quantityInput = this.form.querySelector('[name="quantity"]');
      const quantity = parseInt(quantityInput?.value, 10) || 1;
      const maximum = parseInt(this.dataset.maximumOrderQuantity, 10);

      try {
        const canAdd = await window.maximumOrderQuantity.canAdd(variantId, quantity, maximum);
        if (!canAdd) {
          this.handleErrorMessage(window.variantStrings.maximumOrderQuantityReached);
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          window.maximumOrderQuantity.refresh().catch((error) => console.error(error));
          return;
        }
      } catch (error) {
        console.error(error);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.renderCart());
        formData.append('sections_url', window.location.pathname);
      }

      let productGroup = this.closest('.product')?.querySelector('product-group');

      if (productGroup) {

        let productGroupCurrent = productGroup.dataset.selectedType;
        let productGroupCurrentItem = productGroupCurrent.split(":");
        let productGroupType = productGroupCurrentItem[0].trim();
        let productGroupData = productGroupCurrentItem[1].trim();

        formData.set(`[properties][${productGroupType}]`, productGroupData)
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
              window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            document.body.dataset.cartAction = "added";
          }

          this.error = false;
          window.maximumOrderQuantity.refresh().catch((error) => console.error(error));
          const event = new Event("drawer-toggle");
          this.cartDrawer.dispatchEvent(event);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error && this.submitButton.dataset.maximumQuantityDisabled !== 'true') {
            this.submitButton.removeAttribute('aria-disabled');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {

      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
